module.exports = __webpack_public_path__ + "img/Danger.acd734e2.svg";